exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".header_2ET6C {\n    width: 100%;\n}\n\n.radioButtonLabel_2L8D5 {\n    margin-left: 2px;\n}\n", ""]);

// exports
exports.locals = {
	"header": "header_2ET6C",
	"radioButtonLabel": "radioButtonLabel_2L8D5"
};